import React from "react";
import "./Footer.css";


const Footer = () => {
  return (
    <div className="container d-flex justify-content-center p-3">
      <footer>
        <span className="text-center">
          © 2022 JOTAV DRONE - Todos os direitos reservados.
          | Criação <a href="https://agenciabentech.com.br">Agência Bentech</a>
        </span>
      </footer>
    </div>
  );
};

export default Footer;
